import { jsx as _jsx } from "react/jsx-runtime";
import { isHiylloIcon } from "@hiyllo/icons";
import React from "react";
import { useFontAwesomeIcon } from "./platform";
import { Platform } from "react-native";
export const Icon = React.memo(function Icon(props) {
    const FontAwesomeIcon = useFontAwesomeIcon();
    if (isHiylloIcon(props.icon)) {
        const Icon = props.icon;
        return _jsx(Icon, { color: props.color ?? '#ffffff', width: props.width ?? 15 });
    }
    return _jsx(FontAwesomeIcon, { icon: props.icon, color: props.color ?? '#ffffff', size: props.width ?? 15, 
        // @ts-expect-error --- style cause web
        style: Platform.OS === "web" ? { fontSize: (props.width ?? 15) } : {} });
});
